"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexGapPolyfill = exports.flexGap = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _types = require("./types");
var _ = _interopRequireDefault(require(".."));
var _checkFlexGapSupported = require("./checkFlexGapSupported");
var _excluded = ["children", "dataTestId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var flexGap = exports.flexGap = function flexGap(gap, column) {
  if ((0, _checkFlexGapSupported.checkFlexGapSupported)()) {
    return (0, _styledComponents.css)(["gap:", "px;"], gap);
  }
  return flexGapPolyfill(gap, column);
};
var flexGapPolyfill = exports.flexGapPolyfill = function flexGapPolyfill(gap, column) {
  return (0, _styledComponents.css)([">div,>span,>button{", " &:last-child{", "}}"], column ? "margin-bottom: ".concat(gap, "px;") : "margin-right: ".concat(gap, "px;"), column ? "margin-bottom: 0px;" : "margin-right: 0px;");
};
var ContainerDiv = (0, _styledComponents["default"])(_["default"]).withConfig({
  displayName: "FlexBox__ContainerDiv",
  componentId: "sc-1o5nq9-0"
})(["display:flex;flex-direction:", ";justify-content:", ";align-items:", ";flex-wrap:", ";", " ", ";", ";"], function (props) {
  return props.column ? _types.FlexProps.FlexDirection.COLUMN : _types.FlexProps.FlexDirection.ROW;
}, function (props) {
  return props.justifyContent || (props.spaceBetween ? _types.FlexProps.JustifyContent.SPACE_BETWEEN : _types.FlexProps.JustifyContent.FLEX_START);
}, function (props) {
  return props.alignItems || (props.alignStart ? _types.FlexProps.AlignItems.FLEX_START : _types.FlexProps.AlignItems.CENTER);
}, function (props) {
  return props.flexWrap || (props !== null && props !== void 0 && props.noWrap ? _types.FlexProps.FlexWrap.NOWRAP : _types.FlexProps.FlexWrap.WRAP);
}, function (props) {
  return props.center && "\n        justify-content: center;\n    ";
}, function (props) {
  return props.gap && flexGap(props.gap, props.column);
}, function (props) {
  return props.flexDirection && "\n        flex-direction: ".concat(props.flexDirection, ";\n    ");
});
var FlexBox = function FlexBox(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ContainerDiv, _extends({
    "data-test-id": dataTestId,
    "data-test-class": "sui-flex-container"
  }, props, {
    "data-sentry-element": "ContainerDiv",
    "data-sentry-component": "FlexBox",
    "data-sentry-source-file": "index.tsx"
  }), children);
};
var _default = exports["default"] = FlexBox;